import { Typography, SxProps } from "@mui/material";
import { formatDate } from "../util/datetime";

type LecturePeriodProps = {
    startAt: string,
    endAt: string,
    sx?: SxProps
};

const getPeriod = (startAt: string, endAt: string) => {
    return `受講期間：${formatDate(startAt)} ~ ${formatDate(endAt)}`;
};

export const LecturePeriod: React.FC<LecturePeriodProps> = ({
    sx,
    startAt,
    endAt,
}) => {
    return (
        <Typography 
            variant="body2"
            color="text.secondary"
            sx={sx}
        >
            {getPeriod(startAt, endAt)}
        </Typography>
    );
};
